import type { HTMLAttributes } from 'react';
import type { Descendant } from 'slate';

import { classNames } from '@movingimage-evp/mi-ui-component-library';
import { RichTextEditor } from 'src/components/rich-text-editor';

import styles from './language-editor.module.css';

type Props = {
  language: string;
  description: Descendant[] | undefined;
  onDescriptionChange: (value: Descendant[], language: string) => void;
  onBlur?: () => void;
} & HTMLAttributes<HTMLDivElement>;

export function LanguageEditor({ language, description, onDescriptionChange, onBlur, className }: Props) {
  return (
    <div className={classNames(styles.editorsWrapper, className)}>
      <RichTextEditor
        key={language}
        data-testid={`description-rich-text-editor-${language}`}
        value={description}
        autoFocus
        className={styles.richTextEditor}
        onChange={(value) => {
          if (JSON.stringify(value) === JSON.stringify(description)) {
            return; // Prevent unnecessary updates if the value hasn't changed
          }
          onDescriptionChange(value, language);
        }}
        onBlur={onBlur}
      />
    </div>
  );
}
